import script from "./Benefits.vue?vue&type=script&setup=true&lang=ts"
export * from "./Benefits.vue?vue&type=script&setup=true&lang=ts"

import "./Benefits.vue?vue&type=style&index=0&id=59e4b84e&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59e4b84e"]])

export default __exports__